import {
  provideTransloco,
  TranslocoModule
} from '@ngneat/transloco';
import { isDevMode, NgModule } from '@angular/core';
import { TranslocoHttpLoader } from './transloco-loader';
import { provideTranslocoPersistLang, cookiesStorage } from '@ngneat/transloco-persist-lang';

@NgModule({
  exports: [ TranslocoModule ],
  providers: [
      provideTranslocoPersistLang({
        storage: {
          useValue: typeof window !== 'undefined' ? cookiesStorage() : null,
        },
        storageKey: 'lang'
      }),
      provideTransloco({
        config: {
          availableLangs: ['it', 'en'],
          defaultLang: 'it',
          // Remove this option if your application doesn't support changing language in runtime.
          reRenderOnLangChange: true,
          prodMode: !isDevMode(),
        },
        loader: TranslocoHttpLoader
      }),
  ],
})
export class TranslocoRootModule {}
